module.exports = __webpack_public_path__ + "img/UTPALI.37319547.png";